(function ($) {
	// ヘッダーの高さをその都度取得する関数
	function getHeaderHeight() {
		return $('#masthead').innerHeight() || 0;
	}

	$(window).on('load', function () {
		const $targets = $('#pagetop, #menu-fixed');
		const $footer = $('.l-footer__copy');
		let inFooter = false;

		$targets.hide();

		$(window).on("scroll", function () {
			const scrollTop = $(this).scrollTop();
			const scrollHeight = $(document).height();
			const scrollPosition = $(window).height() + scrollTop;
			const footHeight = $footer.innerHeight();
			const reachedFooter = scrollHeight - scrollPosition <= footHeight;

			if (scrollTop > 500) {
				if (reachedFooter) {
					if (!inFooter) {
						inFooter = true;
						$targets.stop(true).fadeTo(400, 0);
					}
				} else {
					if (inFooter) {
						inFooter = false;
						$targets.stop(true).fadeTo(400, 1);
					} else if (!$targets.is(':visible')) {
						$targets.stop(true).fadeIn(300);
					}
				}
			} else {
				if (inFooter) inFooter = false;
				if ($targets.is(':visible')) {
					$targets.stop(true).fadeOut(300);
				}
			}
		});

		$('#pagetop').on('click', function () {
			$('body,html').stop(true, true).scrollTop(0);
			return false;
		});
	});

	// ページ読み込み時にハッシュがあればスクロール位置調整
	$(window).on('load', function () {
		const urlHash = location.hash;
		if (urlHash) {
			$('body,html').scrollTop(0);
			setTimeout(function () {
				const $target = $(urlHash);
				if ($target.length) {
					const position = $target.offset().top - getHeaderHeight();
					$('body,html').scrollTop(position);
				}
			}, 100);
		}
	});

	// ページ内アンカークリック時のスクロール
	$('a[href^="#"]:not(.notscroll)').on('click', function (e) {
		const href = $(this).attr('href');

		if (href === '#') return;

		const $target = $(href);
		if (!$target.length) return;

		e.preventDefault();

		const position = $target.offset().top - getHeaderHeight();
		$('body,html').scrollTop(position);
	});

})(jQuery);
